var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("default-item", {
    staticClass: "valentines-day_food_item--container",
    attrs: {
      item: _vm.item,
      "pricing-types": _vm.pricingTypes,
      layout: _vm.priceLayout,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }